import { Component, computed, input, output } from '@angular/core';

type ModalSize = 'md' | 'lg' | 'xl';

const ANCHOS: Record<ModalSize, string> = {
  md: 'max-w-lg',
  lg: 'max-w-2xl',
  xl: 'max-w-4xl',
};

/**
 * Diálogo modal simple. Se muestra cuando `abierto` es true; el contenido va
 * como contenido proyectado. Cerrar (botón X, backdrop o Escape) emite `cerrar`.
 *
 *   <ui-modal [abierto]="visible()" titulo="Título" (cerrar)="visible.set(false)">
 *     …contenido…
 *   </ui-modal>
 */
@Component({
  selector: 'ui-modal',
  template: `
    @if (abierto()) {
      <div
        class="fixed inset-0 z-50 flex items-center justify-center bg-black/40 p-4"
        (click)="cerrar.emit()"
      >
        <div
          class="max-h-[90vh] w-full overflow-y-auto rounded-xl bg-white shadow-xl dark:bg-gray-900 {{ ancho() }}"
          role="dialog"
          aria-modal="true"
          (click)="$event.stopPropagation()"
        >
          <header class="flex items-start justify-between gap-4 border-b border-gray-100 px-5 py-4 dark:border-gray-800">
            <div>
              <h3 class="text-base font-bold text-gray-900 dark:text-gray-100">{{ titulo() }}</h3>
              @if (subtitulo()) {
                <p class="mt-0.5 text-sm text-gray-500 dark:text-gray-400">{{ subtitulo() }}</p>
              }
            </div>
            <button
              type="button"
              (click)="cerrar.emit()"
              class="-mr-1 cursor-pointer rounded-md p-1 text-gray-400 transition-colors hover:bg-gray-100 hover:text-gray-600 dark:hover:bg-gray-800 dark:hover:text-gray-300"
              aria-label="Cerrar"
            >
              <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor"
                stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="size-5">
                <path d="M18 6 6 18M6 6l12 12" />
              </svg>
            </button>
          </header>
          <div class="p-5">
            <ng-content />
          </div>
        </div>
      </div>
    }
  `,
  host: { '(document:keydown.escape)': 'abierto() && cerrar.emit()' },
})
export class UiModal {
  readonly abierto = input.required<boolean>();
  readonly titulo = input.required<string>();
  readonly subtitulo = input<string>('');
  readonly size = input<ModalSize>('md');
  readonly cerrar = output<void>();

  protected readonly ancho = computed(() => ANCHOS[this.size()]);
}
